import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";

@Injectable()
export class OdometroHorimetroApiService {

    constructor(
        private _restService: RestService
    ) { }

    onGetByBem(bemId: number, done: any) {
        let filter: any = {"where":{"bemId":bemId},"order":["data"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetLast(bemId: number, done: any) {
        this._restService.onGet(apiName + '/bem/' + bemId, done);
    }


}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/shared/odometro-horimetro-api.service.ts
 **/